import { getFacturaPdfById } from "api/Factura.service"
import { getPagarePdfById } from "api/Pagare.service"
import { EstadoVerificacionEfectoType } from "api/Types/EstadoVerificacionEfecto"
import { TFunction } from "i18next"

export interface EstadoFinanacionDetailResponseProps {
  estadoVerificacion: EstadoVerificacionEfectoType | null
  observaciones: string
}

export const FINANCIACION_TYPE = {
  FACTURAS: 1,
  PAGARES: 2,
} as const

export type FinanciacionType =
  (typeof FINANCIACION_TYPE)[keyof typeof FINANCIACION_TYPE]

export const ESTADO_TIPO_FINANCIACION = (t: TFunction) => {
  return {
    [FINANCIACION_TYPE.FACTURAS]: {
      text: `${t("validaciones.financiable.invoicesText")}`,
      value: FINANCIACION_TYPE.FACTURAS,
    },
    [FINANCIACION_TYPE.PAGARES]: {
      text: `${t("validaciones.financiable.pagateText")}`,
      value: FINANCIACION_TYPE.PAGARES,
    },
  }
}

export const downloadDocumentoFetch = async (
  docType: number,
  documentoID: string
) => {
  const fetchFn = () => {
    switch (docType) {
      case FINANCIACION_TYPE.FACTURAS:
        return getFacturaPdfById(documentoID)
      case FINANCIACION_TYPE.PAGARES:
        return getPagarePdfById(documentoID)
      default:
        return Promise.reject(new Error("Tipo de documento no soportado"))
    }
  }

  const response = await fetchFn()

  if (response?.status === 204) {
    throw new Error("Documento vacío (204)")
  }

  return response.data
}
